import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';

export const FullWidthImage = styled(Image)`
  height: 355px;
  width: 100%;
  object-fit: cover;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    height: 710px;
  }
`;

export const Wrapper = styled.div`
  background-color: ${({ colourOverrideBackground }) =>
    colourOverrideBackground || themeGet('colors.neutral_1')};
`;

export const StyledContainer = styled(Container)`
  position: relative;
  top: -115px;
  && {
    margin-bottom: -115px;
  }

  h1,
  h2,
  h3 {
    color: ${themeGet('colors.text-primary')};
  }

  // * This targets the optional "More from our blog title"
  > h1,
  > h2,
  > h3,
  > h4 {
    position: absolute;
    top: -64px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    top: -170px;
    && {
      margin-bottom: -170px;
    }

    // * This targets the optional "More from our blog title"
    > h1,
    > h2,
    > h3,
    > h4 {
      top: -106px;
    }
  }
`;

export const Card = styled.div`
  background-color: ${({ colourOverrideCardBG }) =>
    colourOverrideCardBG || themeGet('colors.secondary')};
  color: ${themeGet('colors.text-primary')};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 45px 30px;
  border-radius: 12px;

  h2,
  h3,
  p {
    color: inherit;
    margin-bottom: 40px;

    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 26px;
  }

  h2,
  h3 {
    /* for IE */
    width: 100%;
  }

  a {
    color: inherit;
    margin-top: auto;
    padding-bottom: 1px;
    border-bottom: 1px solid currentColor;

    &:focus,
    &:hover {
      color: ${themeGet('colors.accent')};
      opacity: 0.8;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 72px 40px;

    h2,
    h3,
    p {
      color: inherit;
      margin-bottom: 40px;

      font-size: 22px;
      font-weight: bold;
      letter-spacing: -0.5px;
      line-height: 32px;
    }
  }
`;
